require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./restaurants-et-restauration-1-1-12.json") })
        }
      }, "path---restaurants-et-restauration-1-1-12");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---restaurants-et-restauration-1-1-12!./.cache/json/restaurants-et-restauration-1-1-12.json
// module id = 551
// module chunks = 231608221292675